export const experience = [
    {
        title: "Aug 2017 – Apr 2021",
        cardTitle: "Design Hub",
        cardSubtitle: "Software Engineer Intern",
        cardDetailedText: [
            "Meet with clients and write well documented, scalable code to support the client's software needs.",
            "Develop digital mapping software for visually rendering buildings and landscapes from drone scans.",
            "Construct the AI pipeline for an ASL platform used in classrooms to assign and validate practice work."
        ]
    },
    {
        title: "Summer 2019 and Summer 2020",
        cardTitle: "Upward Bound",
        cardSubtitle: "Youth Mentor",
        cardDetailedText: [
            "Guide a designated group of High School students through STEM related coursework to help prepare them for college.",
            "Lead \"Core Group\" exercises where we build community amongst the students and discuss career desires.",
            "Accompany students on field trips, and a residency for a 3 day stay at Sacramento State University."
        ]
    },
    {
        title: "Jun 2018 – Aug 2018",
        cardTitle: "Lawrence Berkeley National Laboratory",
        cardSubtitle: "Computational Research Fellow",
        cardDetailedText: [
            "Develop a Machine Learning platform for crowdsourced Drug Design with 3 other team members.",
            "Wrote scalable software to dispatch & validate our 300gb dataset in parallel using High Performance Computers.",
            "Optimize testing with a custom TensorFlow wrapper, reducing testing time by roughly 50%."
        ]
    },
    {
        title: "Aug 2017 – May 2021",
        cardTitle: "MESA at American River College",
        cardSubtitle: "Python and C++ Tutor",
        cardDetailedText: [
            "Provide ARC students with supplemental coding exercises for relevant data structures and course work.",
            "Assist students in developing test cases to validate software requirements and functionality.",
            "Mentor students on personal projects to make them more competitive on college and internship applications."
        ]
    },
    {
        title: "Aug 2017 – May 2018",
        cardTitle: "Math Club at American River College",
        cardSubtitle: "Club President",
        cardDetailedText: [
            "Organize club meetings and lead sessions centered around competitions with extracurricular study.",
            "Work with students to prepare for our annual Integration Bee and AMATYC Testing.",
            "Raise money for pizza party's and fun get togethers!"
        ]
    },
    {
        title: "Jan 2017 – May 2017",
        cardTitle: "BEACON",
        cardSubtitle: "Group Tutor",
        cardDetailedText: [
            "Tutor college students in Chemistry and Calculus.",
            "Communicate weekly with professors and coordinate course material for review.",
            "Promote team learning and breakdown of complicated problems."
        ]
    }
];

export const experieneTheme={ 
    primary: "steelblue",
    secondary: "rgba(255, 255, 255, 0.6);",
    cardBgColor: "rgba(230, 245, 255, 0.2)",
    cardForeColor: "Black",
    titleColor: "black"
}